import { Grid } from "@mui/material";
import { Form } from "formik";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { loginUser } from "../../../../../actions/login";
import FormikCaptcha from "../../../../commons/formik/formikCaptcha";
import FormikForm from "../../../../commons/formik/formikForm";
import AutoLogin from "./autologin";

const LOGIN_CREDENTIAL = {
  password: "4ttendanceM1CL0UD",
  userName: "attendance",
  token: "",
};

const PublicAttendance = () => {
  const dispatch = useDispatch();
  const captchaRef = useRef(null);

  const handleQRLogin = (values) => {
    dispatch(loginUser(values, values.userName)).catch((error) => {
      captchaRef.current?.reset();
    });
  };

  return (
    <Grid
      container
      alignContent="center"
      alignItems="center"
      sx={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "linear-gradient(120deg, #96d43a, #539aff)",
      }}>
      <FormikForm initialValues={LOGIN_CREDENTIAL} onSubmit={handleQRLogin}>
        <Form>

          <AutoLogin />
          <FormikCaptcha ref={captchaRef} />
        </Form>
      </FormikForm>
    </Grid>
  );
};

export default PublicAttendance;
